/* DC Search Dropdown v1 — /assets/dc-search-dropdown.js
   Instant search dropdown for the header search input.
   Replaces Sobooster (USF) instant search. No dependencies.

   Data source: Shopify Predictive Search API
     GET /search/suggest.json?q=...&resources[type]=product,collection,page

   Anatomy (matches the .dcf-/.dcs- design system):
     - Collections row (chips)
     - Product rows: thumb / title / vendor / "From $" price
     - Pages section (dispatch schedule, contact, etc)
     - Dark footer: view all results + keyboard hints

   Keyboard: ArrowUp/Down to move, Enter to open, Esc to close.
   CSS namespace: .dcqd-
*/
(function(){
  'use strict';

  var input = document.querySelector('.top-bar__search input[name="q"]');
  if(!input) return;
  var form = input.closest('form');
  var wrap = input.closest('.top-bar__search') || form.parentNode;

  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 220;
  var LIMIT = 6;

  // ---------- Styles ----------
  var css = ''
    + '.top-bar__search{position:relative}'
    + '.dcqd{position:absolute;top:100%;left:0;z-index:9000;width:min(560px,calc(100vw - 40px));background:#fff;border:1px solid #e8e8e8;box-shadow:0 6px 18px rgba(0,0,0,.08);font-family:inherit;color:#333;display:none;text-align:left}'
    + '.dcqd.open{display:block}'
    + '.dcqd-label{padding:10px 14px 8px;font-size:11px;font-weight:600;letter-spacing:.6px;color:#999;text-transform:uppercase;border-bottom:1px solid #f0f0f0;margin:0}'
    + '.dcqd-chips{display:flex;gap:8px;padding:10px 14px;flex-wrap:wrap}'
    + '.dcqd-chip{font-size:12px;letter-spacing:.4px;border:1px solid #e8e8e8;background:#f4f4f4;padding:5px 10px;color:#333;text-decoration:none;display:inline-block}'
    + '.dcqd-chip:hover,.dcqd-chip.dcqd-active{border-color:#c8493f;color:#c8493f;background:#fff}'
    + '.dcqd-prods{border-top:1px solid #f0f0f0}'
    + '.dcqd-item{display:flex;align-items:center;gap:12px;padding:9px 14px;text-decoration:none;color:#333;border-left:2px solid transparent}'
    + '.dcqd-item:hover,.dcqd-item.dcqd-active{background:#f4f4f4;border-left-color:#c8493f}'
    + '.dcqd-thumb{width:38px;height:38px;background:#f4f4f4;flex-shrink:0;object-fit:contain}'
    + '.dcqd-thumb-ph{width:38px;height:38px;background:#f0f0f0;flex-shrink:0}'
    + '.dcqd-meta{min-width:0;flex:1}'
    + '.dcqd-title{margin:0;font-size:13px;line-height:1.35;color:#333;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'
    + '.dcqd-sub{margin:0;font-size:11.5px;color:#888;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'
    + '.dcqd-price{margin-left:auto;font-size:13px;font-weight:600;color:#333;white-space:nowrap;padding-left:8px}'
    + '.dcqd-empty{padding:18px 14px;font-size:13px;color:#888}'
    + '.dcqd-foot{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:11px 14px;border-top:1px solid #e8e8e8;background:#333;color:#fff;text-decoration:none}'
    + '.dcqd-foot:hover,.dcqd-foot.dcqd-active{background:#c8493f}'
    + '.dcqd-foot span:first-child{font-size:12px;font-weight:600;letter-spacing:.6px;text-transform:uppercase;color:#fff}'
    + '.dcqd-hint{font-size:11px;color:#aaa;letter-spacing:.4px}'
    + '@media(max-width:749px){.dcqd{display:none !important}}';
  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  // ---------- Dropdown shell ----------
  var dd = document.createElement('div');
  dd.className = 'dcqd';
  dd.setAttribute('role', 'listbox');
  wrap.appendChild(dd);

  var state = { open: false, items: [], active: -1, lastTerm: '', timer: null, seq: 0 };

  function esc(s){
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  function thumbUrl(u){
    if(!u) return null;
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=80';
  }

  function money(p){
    var n = parseFloat(p);
    if(isNaN(n)) return '';
    return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }

  function render(data, term){
    var r = (data && data.resources && data.resources.results) || {};
    var products = r.products || [];
    var collections = r.collections || [];
    var pages = (r.pages || []).slice(0, 3);
    var html = '';

    if(collections.length){
      html += '<p class="dcqd-label">Collections</p><div class="dcqd-chips">';
      collections.slice(0, 4).forEach(function(c){
        html += '<a class="dcqd-chip" data-dcqd-nav href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
      });
      html += '</div>';
    }

    if(products.length){
      html += '<p class="dcqd-label">Products</p><div class="dcqd-prods">';
      products.forEach(function(p){
        var img = thumbUrl(p.featured_image && p.featured_image.url);
        html += '<a class="dcqd-item" data-dcqd-nav href="' + esc(p.url) + '">'
          + (img ? '<img class="dcqd-thumb" loading="lazy" src="' + esc(img) + '" alt="">' : '<span class="dcqd-thumb-ph"></span>')
          + '<span class="dcqd-meta">'
          + '<p class="dcqd-title">' + esc(p.title) + '</p>'
          + (p.vendor ? '<p class="dcqd-sub">' + esc(p.vendor) + '</p>' : '')
          + '</span>'
          + (p.price ? '<span class="dcqd-price">From ' + money(p.price) + '</span>' : '')
          + '</a>';
      });
      html += '</div>';
    }

    if(pages.length){
      html += '<p class="dcqd-label">Pages</p><div class="dcqd-prods">';
      pages.forEach(function(pg){
        html += '<a class="dcqd-item" data-dcqd-nav href="' + esc(pg.url) + '">'
          + '<span class="dcqd-meta"><p class="dcqd-title">' + esc(pg.title) + '</p></span>'
          + '</a>';
      });
      html += '</div>';
    }

    if(!products.length && !collections.length && !pages.length){
      html += '<div class="dcqd-empty">No matches for &ldquo;' + esc(term) + '&rdquo; &mdash; press Enter to search anyway.</div>';
    }

    html += '<a class="dcqd-foot" data-dcqd-nav href="/search?q=' + encodeURIComponent(term) + '">'
      + '<span>View all results</span>'
      + '<span class="dcqd-hint">&#8593;&#8595; navigate &middot; Enter to open &middot; Esc to close</span>'
      + '</a>';

    dd.innerHTML = html;
    state.items = Array.prototype.slice.call(dd.querySelectorAll('[data-dcqd-nav]'));
    state.active = -1;
    openDd();
  }

  function openDd(){ dd.classList.add('open'); state.open = true; }
  function closeDd(){ dd.classList.remove('open'); state.open = false; state.active = -1; }

  function setActive(i){
    state.items.forEach(function(el){ el.classList.remove('dcqd-active'); });
    state.active = i;
    if(i >= 0 && state.items[i]){
      state.items[i].classList.add('dcqd-active');
      if(state.items[i].scrollIntoView) state.items[i].scrollIntoView({ block: 'nearest' });
    }
  }

  function fetchSuggestions(term){
    var seq = ++state.seq;
    var url = '/search/suggest.json'
      + '?q=' + encodeURIComponent(term)
      + '&resources[type]=product,collection,page'
      + '&resources[limit]=' + LIMIT
      + '&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=title,product_type,variants.title,vendor';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function(res){ return res.json(); })
      .then(function(data){
        if(seq !== state.seq) return;            // stale response — a newer query is in flight
        if(document.activeElement !== input && !state.open) return;
        render(data, term);
      })
      .catch(function(){ /* network hiccup — keep quiet, native search still works */ });
  }

  input.setAttribute('autocomplete', 'off');
  input.addEventListener('input', function(){
    var term = input.value.trim();
    clearTimeout(state.timer);
    if(term.length < MIN_CHARS){ closeDd(); state.lastTerm = ''; return; }
    state.timer = setTimeout(function(){
      if(term === state.lastTerm && state.open) return;
      state.lastTerm = term;
      fetchSuggestions(term);
    }, DEBOUNCE_MS);
  });

  input.addEventListener('focus', function(){
    var term = input.value.trim();
    if(term.length >= MIN_CHARS) fetchSuggestions(term);
  });

  input.addEventListener('keydown', function(e){
    if(!state.open) return;
    if(e.key === 'ArrowDown'){
      e.preventDefault();
      setActive(state.active + 1 >= state.items.length ? 0 : state.active + 1);
    } else if(e.key === 'ArrowUp'){
      e.preventDefault();
      setActive(state.active - 1 < 0 ? state.items.length - 1 : state.active - 1);
    } else if(e.key === 'Enter'){
      if(state.active >= 0 && state.items[state.active]){
        e.preventDefault();
        window.location.href = state.items[state.active].href;
      }
      // no active item — let the form submit to /search?q= natively
    } else if(e.key === 'Escape'){
      closeDd();
    }
  });

  document.addEventListener('click', function(e){
    if(!wrap.contains(e.target)) closeDd();
  });
})();
